import { render, staticRenderFns } from "./CertificationDialog.vue?vue&type=template&id=c1657828&scoped=true&"
import script from "./CertificationDialog.vue?vue&type=script&lang=js&"
export * from "./CertificationDialog.vue?vue&type=script&lang=js&"
import style0 from "./CertificationDialog.vue?vue&type=style&index=0&id=c1657828&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1657828",
  null
  
)

export default component.exports